//
// SpanElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "../../visualElements/actions/AbstractAction";

var SpanElement = createModule("BIRD::SpanElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        spans: [1],
        action: 1,
        styleClass: 7,
        content: 7,
    },
    {
        parentSpan: 1,
    },
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SpanElement;
